



































































import moment from 'moment';
import { ResourceLoader } from 'mycorems-app-shared';
import { HasTaskMixin } from '@/mixins';
import { ClientSummary, ClientSummaryFilters, DateRange } from '@/types';
import { round } from '@/utils';
import ScoreCard from '@/components/ScoreCard.vue';
import repository from './client-repository';
import DateRangeFilter from '../DateRangeFilter.vue';

interface Data {
  clientSummary: ClientSummary|null,
  startDate: string|null,
  endDate: string|null,
}

export default HasTaskMixin.extend({
  props: {
    clientId: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      clientSummary: null,
      startDate: null,
      endDate: null,
    };
  },
  computed: {
    filters(): ClientSummaryFilters {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
      };
    },
  },
  watch: {
    filters: {
      handler(): void {
        this.load();
      },
      deep: true,
    },
  },
  methods: {
    clear(): void {
      this.startDate = null;
      this.endDate = null;
    },
    selectRange(range: DateRange) {
      this.startDate = range.start;
      this.endDate = range.end;
    },
    load(): void {
      this.task = repository.findSummary(this.clientId, this.filters);
      this.task.then((clientSummary: ClientSummary) => {
        this.clientSummary = clientSummary;
        if (this.clientSummary.firstCampaignDate !== null) {
          this.startDate = this.clientSummary.firstCampaignDate;
          if (!this.endDate) {
            this.endDate = moment().format('YYYY-MM-DD');
          }
        }
      });
    },
    round,
  },
  created(): void {
    this.load();
  },
  components: {
    'resource-loader': ResourceLoader,
    'date-range-filter': DateRangeFilter,
    'score-card': ScoreCard,
  },
});
